import { Component, OnInit, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { User } from '../models/user';

@Component({
    selector: 'app-account-management',
    templateUrl: './account-management.component.html',
    styleUrls: ['./account-management.component.css'],
    standalone: false
})
export class AccountManagementComponent implements OnInit {
  authSvc = inject(AuthService);


  showAddLocationDialog = false;
  showAddUserDialog = false;
  public user!: User;

  constructor() {
    this.user = this.authSvc.user;
  }

  ngOnInit(): void {  
    // Block access to the account management for non-admins
    if(this.user.role != "DDPD" && this.user.role != "DDPC"){
      this.authSvc.redirectToErrorByID(1002);
    }
        const body = document.getElementsByTagName("body")[0];
    body.className = "";
    body.classList.add("subpage");
    body.classList.add("accountManagement");
  }

}
